<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentf"><a id="fm01"></a><a id="page_xiii">Thirty-three years after he was arrested for conspiring to steal atomic secrets, I began my search for David Greenglass. He had changed his name and vanished. Once I found him, it took me thirteen years to finally persuade him to speak fully for the first time about why he enlisted as a Russian spy and later delivered his sister, Ethel Rosenberg, and her husband, Julius, to their deaths in Sing Sing’s electric chair. Our more than fifty hours of uncensored conversations, fleshed out with other revelations about the investigation, trial, and execution of the Rosenbergs, form the backbone of <span class="txit">The Brother</span>.</a></p><a id="page_xiii">
</a><p class="indentf"><a id="page_xiii">David could not veto anything I wrote. He read it for the first time in this book. So did his wife and children, whom he never told about our collaboration.</a><a id="page_1"></a><a id="page_2"></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?40c43edc